import { useEffect } from "react";

/**
 * Sets the browser tab title while an SMRU partner page is mounted and restores
 * it on unmount. The favicon is intentionally left untouched — every tab keeps
 * the default AI.Prof favicon.ico.
 */
export function usePartnerTab(title) {
    useEffect(() => {
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        };
    }, [title]);
}
